import React from 'react'
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts'
import { Card } from 'antd'

interface EfficiencyData {
  name: string
  efficiency: number
  target: number
}

interface EfficiencyTrendChartProps {
  data: EfficiencyData[]
  height?: number
  title?: string
}

export const EfficiencyTrendChart: React.FC<EfficiencyTrendChartProps> = ({
  data,
  height = 300,
  title = 'Personnel Efficiency Trend',
}) => {
  return (
    <Card title={title} bordered style={{ marginBottom: '24px' }}>
      <ResponsiveContainer width="100%" height={height}>
        <LineChart data={data} margin={{ top: 5, right: 30, left: 0, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis label={{ value: 'Efficiency (%)', angle: -90, position: 'insideLeft' }} />
          <Tooltip
            formatter={(value) => `${typeof value === 'number' ? value.toFixed(1) : value}%`}
            contentStyle={{ backgroundColor: '#f5f5f5', border: '1px solid #d9d9d9' }}
          />
          <Legend />
          <Line
            type="monotone"
            dataKey="efficiency"
            stroke="#52c41a"
            strokeWidth={2}
            dot={{ fill: '#52c41a', r: 4 }}
            activeDot={{ r: 6 }}
            name="Actual Efficiency"
          />
          <Line
            type="monotone"
            dataKey="target"
            stroke="#faad14"
            strokeWidth={2}
            strokeDasharray="5 5"
            dot={{ fill: '#faad14', r: 4 }}
            name="Target Efficiency"
          />
        </LineChart>
      </ResponsiveContainer>
    </Card>
  )
}
